import { render, staticRenderFns } from "./HomeFaqs.vue?vue&type=template&id=47208ca6&scoped=true&"
import script from "./HomeFaqs.vue?vue&type=script&lang=js&"
export * from "./HomeFaqs.vue?vue&type=script&lang=js&"
import style0 from "./HomeFaqs.vue?vue&type=style&index=0&id=47208ca6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47208ca6",
  null
  
)

export default component.exports